import moment from 'moment';
export default {
  validate(control, rule, value, callback) {
    if (value && value[control.field]) {
      const date = new Date(value[control.field]);
      const now = moment().utcOffset(0, true).toDate();

      if (date.getFullYear() > now.getFullYear() + 1
        || (date.getFullYear() === now.getFullYear() + 1 && date.getMonth() > now.getMonth())) {
        callback("Nevažeći datum.");
        return;
      }
    }

    callback();
  },
};



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/MonthYearValidator.ts